// Dynamic Loading Modules

// Views
const Dashboard = (resolve) => {
  require.ensure(["../views/Dashboard.vue"], () => {
    resolve(require("../views/Dashboard.vue"));
  });
};

// UI Components
const Buttons = (resolve) => {
  require.ensure(["../components/Buttons.vue"], () => {
    resolve(require("../components/Buttons.vue"));
  });
};
const Badges = (resolve) => {
  require.ensure(["../components/Badges.vue"], () => {
    resolve(require("../components/Badges.vue"));
  });
};
const Alerts = (resolve) => {
  require.ensure(["../components/Alerts.vue"], () => {
    resolve(require("../components/Alerts.vue"));
  });
};
const ProgressBars = (resolve) => {
  require.ensure(["../components/ProgressBars.vue"], () => {
    resolve(require("../components/ProgressBars.vue"));
  });
};

const BasicForms = (resolve) => {
  require.ensure(["../components/forms/BasicForms.vue"], () => {
    resolve(require("../components/forms/BasicForms.vue"));
  });
};
const Grids = (resolve) => {
  require.ensure(["../components/Grids.vue"], () => {
    resolve(require("../components/Grids.vue"));
  });
};
const Widgets = (resolve) => {
  require.ensure(["../components/Widgets.vue"], () => {
    resolve(require("../components/Widgets.vue"));
  });
};
const Typography = (resolve) => {
  require.ensure(["../components/Typography.vue"], () => {
    resolve(require("../components/Typography.vue"));
  });
};
const Icons = (resolve) => {
  require.ensure(["../components/icons/Icons.vue"], () => {
    resolve(require("../components/icons/Icons.vue"));
  });
};
const SetsList = (resolve) => {
  require.ensure(["../components/icons/SetsList.vue"], () => {
    resolve(require("../components/icons/SetsList.vue"));
  });
};
const Sets = (resolve) => {
  require.ensure(["../components/icons/Set.vue"], () => {
    resolve(require("../components/icons/Set.vue"));
  });
};
const Tables = (resolve) => {
  require.ensure(["../components/tables/Tables.vue"], () => {
    resolve(require("../components/tables/Tables.vue"));
  });
};

//Charts
const ChartJS = (resolve) => {
  require.ensure(["../components/charts/ChartJS.vue"], () => {
    resolve(require("../components/charts/ChartJS.vue"));
  });
};

//Maps
const GoogleMapsPage = (resolve) => {
  require.ensure(["../components/maps/google-maps/GoogleMapsPage.vue"], () => {
    resolve(require("../components/maps/google-maps/GoogleMapsPage.vue"));
  });
};
const LeafletMapsPage = (resolve) => {
  require.ensure(
    ["../components/maps/leaflet-maps/LeafletMapsPage.vue"],
    () => {
      resolve(require("../components/maps/leaflet-maps/LeafletMapsPage.vue"));
    }
  );
};

// // User Info
// const User = resolve => { require.ensure(['../layouts/User.vue'], ()=>{ resolve(require('../layouts/User.vue')); }); };

//Pages
const Login = (resolve) => {
  require.ensure(["../pages/login/Login.vue"], () => {
    resolve(require("../pages/login/Login.vue"));
  });
};
const Register = (resolve) => {
  require.ensure(["../pages/register/Register.vue"], () => {
    resolve(require("../pages/register/Register.vue"));
  });
};
const Page404 = (resolve) => {
  require.ensure(["../pages/Page404.vue"], () => {
    resolve(require("../pages/Page404.vue"));
  });
};
const Page500 = (resolve) => {
  require.ensure(["../pages/Page500.vue"], () => {
    resolve(require("../pages/Page500.vue"));
  });
};
/************************************************************ */
/**Todo lo anterior son los componentes del template */
//Admin components
const Usuarios = (resolve) => {
  require.ensure(["../pages/admin/panel/usuarios.vue"], () => {
    resolve(require("../pages/admin/panel/usuarios.vue"));
  });
};
const adminHome = (resolve) => {
  require.ensure(["../pages/admin/home.vue"], () => {
    resolve(require("../pages/admin/home.vue"));
  });
};
const Empresa = (resolve) => {
  require.ensure(["../pages/admin/panel/empresa.vue"], () => {
    resolve(require("../pages/admin/panel/empresa.vue"));
  });
};
const Departamentos = (resolve) => {
  require.ensure(["../pages/admin/panel/departamentos.vue"], () => {
    resolve(require("../pages/admin/panel/departamentos.vue"));
  });
};
const Puestos = (resolve) => {
  require.ensure(["../pages/admin/panel/puestos.vue"], () => {
    resolve(require("../pages/admin/panel/puestos.vue"));
  });
};

//Admin RH
const Incidencias = (resolve) => {
  require.ensure(["../pages/admin/adminrh/incidencias.vue"], () => {
    resolve(require("../pages/admin/adminrh/incidencias.vue"));
  });
};
const Turnos = (resolve) => {
  require.ensure(["../pages/admin/adminrh/turnos.vue"], () => {
    resolve(require("../pages/admin/adminrh/turnos.vue"));
  });
};

const ListadoPersonal = (resolve) => {
  require.ensure(["../pages/admin/personal/listadoPersonal.vue"], () => {
    resolve(require("../pages/admin/personal/listadoPersonal.vue"));
  });
};

const formPersonal = (resolve) => {
  require.ensure(["../pages/admin/personal/formPersonal.vue"], () => {
    resolve(require("../pages/admin/personal/formPersonal.vue"));
  });
};

const viewPersonal = (resolve) => {
  require.ensure(["../pages/admin/personal/viewPersonal.vue"], () => {
    resolve(require("../pages/admin/personal/viewPersonal.vue"));
  });
};

const asignacionHorario = (resolve) => {
  require.ensure(["../pages/admin/personal/asignacionHorarios.vue"], () => {
    resolve(require("../pages/admin/personal/asignacionHorarios.vue"));
  });
};

const asignacionIncidencia = (resolve) => {
  require.ensure(["../pages/admin/personal/asignacionIncidencias.vue"], () => {
    resolve(require("../pages/admin/personal/asignacionIncidencias.vue"));
  });
};

const calendarioPersonal = (resolve) => {
  require.ensure(["../pages/admin/personal/calendario.vue"], () => {
    resolve(require("../pages/admin/personal/calendario.vue"));
  });
};

export const routes = [
  {
    path: "",
    name: "home",
    redirect: "/access/login",
    components: {
      default: Dashboard,
    },
  },
  {
    path: "/dashboard",
    components: {
      default: Dashboard,
    },
  },

  // // UI Components
  { path: "/components/buttons", name: "buttons", component: Buttons },
  { path: "/components/badges", name: "badges", component: Badges },
  { path: "/components/alerts", name: "alerts", component: Alerts },
  {
    path: "/components/progressbars",
    name: "progressbars",
    component: ProgressBars,
  },
  { path: "/components/basic-form", name: "basic-form", component: BasicForms },
  { path: "/components/grids", name: "grids", component: Grids },
  { path: "/components/widgets", name: "widgets", component: Widgets },
  { path: "/components/typography", name: "typography", component: Typography },
  { path: "/components/tables", name: "tables", component: Tables },
  //// Modulos admin
  // Aqui comeinzan los routers del proyecto RRHH admin
  { path: "/admin/home", name: "home", component: adminHome },
  { path: "/admin/panel/usuarios/", name: "usuarios", component: Usuarios },
  { path: "/admin/panel/empresa/", name: "empresa", component: Empresa },
  {
    path: "/admin/panel/departamentos/",
    name: "departamentos",
    component: Departamentos,
  },
  { path: "/admin/panel/puestos/", name: "puestos", component: Puestos },
  // admin RH
  {
    path: "/admin/rh/incidencias",
    name: "incidencias",
    component: Incidencias,
  },
  { path: "/admin/rh/turnos", name: "turnos", component: Turnos },
  //Personal
  {
    path: "/admin/personal/listado",
    name: "listadoPersonal",
    component: ListadoPersonal,
  },
  {
    path: "/admin/personal/form",
    name: "Agregar Personal",
    component: formPersonal,
  },
  {
    path: "/admin/personal/form/:id",
    name: "Editar Personal",
    props: true,
    component: formPersonal,
  },
  {
    path: "/admin/personal/ver/:id",
    name: "Detalle Persona",
    props: true,
    component: viewPersonal,
  },
  {
    path: "/admin/personal/asignacionHorarios",
    name: "Asignacion de Horarios Persona",
    //props: true,
    component: asignacionHorario,
  },
  {
    path: "/admin/personal/asignacionincidencias",
    name: "Asignacion de Incidencias Persona",
    //props: true,
    component: asignacionIncidencia,
  },
  {
    path: "/admin/personal/calendario",
    name: "Calendario Personal",
    //props: true,
    component: calendarioPersonal,
  },

  {
    path: "/components/icons",
    component: Icons,
    children: [
      {
        path: "",
        component: SetsList,
        name: "Icons",
      },
      {
        path: ":name",
        component: Sets,
        props: true,
      },
    ],
  },
  {
    path: "/components/charts",
    name: "Charts",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "/components/chartjs",
        component: ChartJS,
        name: "chart-js",
      },
    ],
  },
  {
    path: "/components/maps",
    name: "Maps",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "/components/maps/google-maps",
        component: GoogleMapsPage,
        name: "google-maps-page",
      },
      {
        path: "/components/maps/leaflet-maps",
        component: LeafletMapsPage,
        name: "leaflet-maps-page",
      },
    ],
  },
  {
    path: "/components/usuario",
    name: "usuario",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "/access/login",
        component: Login,
        name: "login",
        meta: {
          default: false,
          title: "Login",
        },
      },
      {
        path: "/access/register",
        component: Register,
        name: "Register",
      },
      {
        path: "/access/Page404",
        component: Page404,
        name: "Page404",
      },
      {
        path: "/access/Page500",
        component: Page500,
        name: "Page500",
      },
    ],
  },

  //Redirect to Home
  { path: "/redirect-me", redirect: { name: "home" } },

  // 404 redirect to home
  { path: "*", redirect: { name: "Page404", component: Page404 } },
];
